export default "__VITE_ASSET__CS8xXZS___"